import { INIT } from "./actions.js";
function apiConfigReducer(state = null, action) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}
export {
  apiConfigReducer as default
};
//# sourceMappingURL=reducer.js.map
